import { CheckOutlined } from '@ant-design/icons';
import { Col, Row, Image } from 'antd';
import React from 'react';

const MessageInfoBox: React.FC<{
    message: MessageObj;
    profileImg:string;
    username:string

}> = ({
    message,
    profileImg,
    username
}) => {
        return (
            <div className='mt-2 mb-2'>
                <div dir="ltr"
                    className='info-box'>
                    <div dir="auto" className="css-901oao">
                        <div>
                            <span className="css-901oao css-16my406">
                                <div role="none"
                                    className="info-img-cover">
                                    <div className='info-img'
                                        style={{ backgroundImage: `url(${profileImg})` }}>
                                    </div>
                                </div>
                            </span><span className="css-901oao css-16my406 r-op4f77 r-1loqt21 r-krhiga r-1enofrn r-1kfrs79"><strong>{username}</strong></span>
                            <div dir="auto" className="css-901oao r-op4f77 r-1enofrn r-16dba41"> {message.message}</div>
                            </div>
                    </div>
                </div>
            </div>
        );
    }

export default MessageInfoBox;
